<!--  -->
<template>
  <div class="div_ucBusRouteLine">
    <el-tabs
      class="el-tabs-routeBus"
      type="card"
      v-model="ucSetting.tabIndex"
      @tab-click="_tabClickHandler"
    >
      <el-tab-pane
        v-for="transferTypeItem in busTransferTypes"
        :key="transferTypeItem.id"
        :label="transferTypeItem.label"
        :name="transferTypeItem.id"
      >

        <div
          v-show="ucSetting.noBusLinesTip"
          class="div_span_noBusLines"
        >
          <span class="span_noBusLines">未查询到相关公交线路</span>
        </div>

        <div v-show="!ucSetting.noBusLinesTip">
          <el-collapse
            class="el-collapse-routeBus"
            v-if="ucSetting.tabIndex==transferTypeItem.id"
            accordion
            @change="_collapseChangeHandler"
          >

            <el-collapse-item
              v-bind:class="{'el-collapse-item_linePlan':true,'el-collapse-routeBus-selected':linePlanItem.selectedStatus}"
              v-for="linePlanItem in lineItems.objects"
              :key="linePlanItem.id"
              :title="linePlanItem.lineNameDesc"
              :name="linePlanItem.id"
            >
              <UCBusSegmentItems ref="ucSegmentItems"></UCBusSegmentItems>

            </el-collapse-item>

          </el-collapse>
        </div>

      </el-tab-pane>

    </el-tabs>

  </div>
</template>

<script>
import UCBusSegmentItems from "./UCBusSegmentItems.vue";

import { UCRouteConstant, RouteSearchType, UCRouteEvent } from "./UCRouteJs.js";
import { RouteFilter, RouteSearchResult } from "../model/Route.js";
import { BusTransferType } from "../../../utility/tdtService/BusTransfer/Model/BusTransferType";
import { BusTransferInfo } from "../../../utility/tdtService/BusTransfer/Model/BusTransferInfo";
import { LinePlanItems } from "../../../utility/tdtService/BusTransfer/Model/LinePlanItems";

export default {
  name: "UCBusRouteLine",
  data() {
    return {
      ucSetting: {
        tabIndex: 0,
        fosedTab: null,

        noBusLinesTip: false
      },

      callbacks: {
        segmentItemClick: null,

        segmentEndNameClick: null
      },

      //公交换乘类型
      busTransferTypes: UCRouteConstant.busTransferTypes,

      //当前换乘类型，默认为少换乘
      curTransferType: BusTransferType.LessTransfer,

      //搜索参数
      searchParams: null,

      //公交车换乘信息
      busTransferInfo: new BusTransferInfo(),

      lineItems: new LinePlanItems(),

      startPOIName: "",

      endPOIName: ""
    };
  },

  components: { UCBusSegmentItems },

  computed: {},

  mounted() {},

  methods: {
    init() {
      if (this.searchParams) {
        this._searchBusTransfer();
        this.startPOIName = this.searchParams.startPoint.POI.name;
        this.endPOIName = this.searchParams.endPoint.POI.name;
      }
    },

    on_busTransferInfoSearchFinished(callback) {
      if (callback) {
        this.$on(
          UCRouteEvent.UCBusRouteLine_busTransferInfoSearchFinished,
          callback
        );
      }
    },

    on_lineItemClick(callback) {
      if (callback) {
        this.$on(UCRouteEvent.UCBusRouteLine_lineItemClick, callback);
      }
    },

    on_segmentItemClick(callback) {
      this.callbacks.segmentItemClick = callback;
    },

    on_segmentEndNameClick(callback) {
      this.callbacks.segmentEndNameClick = callback;
    },

    _searchBusTransfer() {
      let self = this;
      let filter = new RouteFilter();
      filter.startPositionX = this.searchParams.startPoint.POI.x;
      filter.startPositionY = this.searchParams.startPoint.POI.y;
      filter.endPositionX = this.searchParams.endPoint.POI.x;
      filter.endPositionY = this.searchParams.endPoint.POI.y;
      //筛选类型
      filter.filterType = RouteSearchType.national_busTransfer;
      filter.transferType = this.curTransferType;

      RouteSearchResult.search(
        filter,
        function(response) {
          if (response.resultObject) {
            self.busTransferInfo = response.resultObject;
            self.lineItems = self.busTransferInfo.plans;

            if (self.lineItems.length <= 0) {
              self.ucSetting.noBusLinesTip = true;
            } else {
              self.ucSetting.noBusLinesTip = false;
            }
          } else {
            self.ucSetting.noBusLinesTip = true;
          }

          //触发事件
          self.$emit(
            UCRouteEvent.UCBusRouteLine_busTransferInfoSearchFinished,
            self.routeInfo
          );
        },
        function(erorr) {}
      );
    },

    _tabClickHandler(tab, event) {
      if (!tab) return;

      let tabIndex = parseInt(tab.index);

      if (tabIndex === 0) {
        this.curTransferType = BusTransferType.LessTransfer;
      } else if (tabIndex === 1) {
        this.curTransferType = BusTransferType.LessWalk;
      } else if (tabIndex === 2) {
        this.curTransferType = BusTransferType.MoreQuick;
      } else if (tabIndex === 3) {
        this.curTransferType = BusTransferType.NotSubway;
      }

      this._searchBusTransfer();
    },

    _collapseChangeHandler(focusedLineId) {
      if (focusedLineId) {
        let itemIndex = this.lineItems.findIndexById(focusedLineId);
        

        let linePlanItem = this.lineItems.objects[itemIndex];

        //设置当前选中状态
        this.lineItems.resetSelectedStatus();
        linePlanItem.selectedStatus=true;

        let segmentItems = linePlanItem.segments;

        // let segments = segmentItems.objects;

        this.$refs.ucSegmentItems[itemIndex].segmentItems = segmentItems;
        this.$refs.ucSegmentItems[itemIndex].startPOIName = this.startPOIName;
        this.$refs.ucSegmentItems[itemIndex].endPOIName = this.endPOIName;

        this.$refs.ucSegmentItems[itemIndex].off_segmentItemClick(
          this.callbacks.segmentItemClick
        );
        this.$refs.ucSegmentItems[itemIndex].off_segmentEndNameClick(
          this.callbacks.segmentEndNameClick
        );
        this.$refs.ucSegmentItems[itemIndex].on_segmentItemClick(
          this.callbacks.segmentItemClick
        );
        this.$refs.ucSegmentItems[itemIndex].on_segmentEndNameClick(
          this.callbacks.segmentEndNameClick
        );
        this.$refs.ucSegmentItems[itemIndex].init();

        this.$emit(UCRouteEvent.UCBusRouteLine_lineItemClick, linePlanItem);
      } else {
        //重置选中状态
        this.lineItems.resetSelectedStatus();

        this.$emit(UCRouteEvent.UCBusRouteLine_lineItemClick, null);
      }
    },

    
  }
};
</script>

<style lang="scss" scoped>
// @import "../../../assets/styles/elcollapse.scss";
// @import "../../../assets/styles/elTabs.scss";

.div_ucBusRouteLine {
  width: 100%;
  height: 100%;
  padding: 5px 15px 5px 15px;
  font-size: 12px;
}

.el-collapse-item_linePlan {
  cursor: pointer;
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}


.div_span_noBusLines {
  text-align: center;

  .span_noBusLines {
    color: #2f87eb;
    font-size: 16px;
    display: inline-block;
  }
}



/deep/ .el-tabs-routeBus {
  height: 100%;

  .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 5px;
  }

  .el-tabs__item {
    font-size: 12px;
    height: 26px;
    line-height: 26px;
  }

  .el-tabs__content {
    height: 80%;
    flex-grow: 1;
    overflow-y: auto;

    .el-tab-pane {
      height: 100%;
    }
  }
}

/deep/.el-collapse-routeBus {
  border-top: none;
  border-bottom: none;
  padding: 15px 0;

  .el-collapse-item {
    padding-bottom: 5px;

    .el-collapse-item__content {
      font-size: 12px;
    }

    .el-collapse-item__header {
      //修改高度为32
      height: 100%;
      line-height: 32px;

      //修改字体
      font-size: 12px;
      //修改颜色
      color: #000;

      background-color: #fff;

      .el-collapse-item__arrow {
        display: none;
      }
    }
  }
}


/deep/.el-collapse-routeBus-selected {
  .el-collapse-item__header {

      background-color:#f0f7ff!important;
      
    }
}
</style>
